import { Component, OnInit, TemplateRef } from '@angular/core';
import {
	AbstractControl,
	FormControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENTION } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { MissionPlace } from 'src/app/shared/models/mission/mission-place';
import { Specialite } from 'src/app/shared/models/specialite';

@Component({
	selector: 'app-detail-mission-place',
	templateUrl: './detail-mission-place.component.html',
	styleUrls: ['./detail-mission-place.component.scss']
})
export class DetailMissionPlaceComponent implements OnInit {
	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp(
		"^[0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+( [0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+)*$"
	);

	missionPlaces: MissionPlace[] = null;
	missionPlace: MissionPlace = null;
	confirmDeleteModalRef: BsModalRef;
	isDeletable: boolean;

	labelIntervention: string;

	isFormReadOnly = true;

	missionPlaceDetailForm = new FormGroup({
		address: new FormControl('', [
			Validators.required,
			this.isAddressValidValidator()
		]),
		name: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		notes: new FormControl('', Validators.maxLength(1023))
	});

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	listSelectedSpecialite: Specialite[];

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: BsModalService,
		private facade: FacadeService
	) {}

	ngOnInit(): void {
		this.isDeletable = this.facade.dataStorageService.isPlanificatrice();
		const id = +this.route.snapshot.paramMap.get('id');
		this.facade.missionPlaceService
			.getMissionPlaceById(id)
			.subscribe((missionPlace: MissionPlace) => {
				this.missionPlace = missionPlace;
				this.resetForm();

				// Deep copy
				this.listSelectedSpecialite = [...this.missionPlace.specialties];
			});
		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);
	}

	goBack(): void {
		this.router.navigate(['/gestion/mission-places/list']);
	}

	delete(missionPlace: MissionPlace): void {
		if (this.isDeletable) {
			this.facade.missionPlaceService
				.deleteMissionPlace(missionPlace.id)
				.subscribe((_) => {
					this.modalService.hide();
					this.goBack();
				});
		}
	}

	openConfirmDeleteModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm() {
		this.isFormReadOnly = false;
	}

	stopEditForm(isSubmit: boolean) {
		this.isFormReadOnly = true;
		this.listSelectedSpecialite = [...this.missionPlace.specialties];
		this.isValidateButtonClicked.value = false;
		this.resetForm();
	}

	onSubmit() {
		if (
			this.missionPlaceDetailForm.valid &&
			(this.isAddressDefault.value || this.isAddressSelected.value)
		) {
			this.isValidateButtonClicked.value = true;
			this.facade.missionPlaceService
				.updateMissionPlace(this.missionPlace)
				.subscribe({
					complete: () => {
						this.missionPlace.version += 1;
						this.stopEditForm(true);
					},
					error: (err) => {
						this.stopEditForm(true);
						// On va chercher la nouvelle version de l'employé
						this.facade.missionPlaceService
							.getMissionPlaceById(this.missionPlace.id)
							.subscribe((missionPlace: MissionPlace) => {
								this.missionPlace = missionPlace;
							});
					}
				});
		} else {
			this.isValidateButtonClicked.value = false;
		}
	}

	resetForm() {
		this.missionPlaceDetailForm.reset();
		this.missionPlaceDetailForm.setValue({
			address: this.missionPlace.address.label,
			name: this.missionPlace.name,
			notes: this.missionPlace.notes
		});
	}

	specialitiesAsString() {
		let str = '';
		this.missionPlace.specialties
			.sort((a, b) => a.name.localeCompare(b.name))
			.forEach((e) => (str += e.name + ', '));
		return str.slice(0, -2);
	}

	isAddressValidValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			return (this.isAddressDefault || this.isAddressSelected) &&
				!(this.isAddressDefault.value || this.isAddressSelected.value)
				? { invalidAddress: { value: control.value } }
				: null;
		};
	}
}
